import { Button, NonIdealState } from "@blueprintjs/core";

export function ErrorBoundaryFallbackReload() {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <NonIdealState
        icon="error"
        title="Something went wrong"
        description="Please try reloading the page."
        action={
          <Button
            icon="refresh"
            text="Reload"
            onClick={() => window.location.reload()}
          />
        }
      />
    </div>
  );
}
